import React, { useState } from 'react';
import {
  InstagramOutlined,
  FacebookOutlined,
  TwitterOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
  MailOutlined,
  WhatsAppOutlined,
  ShoppingOutlined,
  HomeOutlined,
  GiftOutlined,
  ClockCircleOutlined,
  ThunderboltOutlined,
  MessageOutlined,
} from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { Input, Button, notification, Tag } from 'antd';

function Footer() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleEmailSubmit = async () => {
    if (!email || !email.includes('@')) {
      notification.error({
        message: 'Invalid Email',
        description: 'Please enter a valid email address.',
      });
      return;
    }

    setLoading(true);
    try {
      const whatsappMessage = `*NEWSLETTER SUBSCRIPTION*%0A%0A` +
                             `📧 *Email:* ${email}%0A` +
                             `⏰ *Time:* ${new Date().toLocaleString()}%0A%0A` +
                             `_Please subscribe this email to your newsletter list_`;
      
      const whatsappUrl = `https://wa.me/254729335354?text=${whatsappMessage}`;
      
      window.open(whatsappUrl, '_blank');
      
      notification.success({
        message: 'Subscription Started!',
        description: 'Please send the WhatsApp message to complete your subscription.',
        duration: 5,
      });
      
      setEmail('');
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to process subscription. Please try again.',
      });
    } finally {
      setLoading(false);
    }
  };

  const paymentMethods = [
    { name: 'Visa', img: 'https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg' },
    { name: 'MasterCard', img: 'https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg' },
    { name: 'M-Pesa', img: 'https://upload.wikimedia.org/wikipedia/commons/0/0f/M-PESA_LOGO-01.svg' },
    { name: 'Airtel Money', img: 'https://upload.wikimedia.org/wikipedia/en/1/1a/Airtel_Money_logo.svg' },
  ];

  return (
    <footer
      style={{
        backgroundColor: '#0a0a0a',
        color: '#ffffff',
        padding: '60px 20px 30px',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        position: 'relative',
        overflow: 'hidden',
        borderTop: '4px solid #ff6b35',
      }}
    >
   

      <div
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '40px',
          alignItems: 'start',
        }}
      >
        {/* Column 1: Brand & 24/7 Info */}
        <div style={{ textAlign: 'left' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/erps-cdea6.firebasestorage.app/o/logo%2FWhatsApp%20Image%202024-12-20%20at%201.39.20%20AM%20(1).jpeg?alt=media&token=257e54a4-24e2-4215-8bf6-fd088256b8f1"
              alt="Dollar Furniture"
              style={{ 
                width: '70px', 
                height: '70px',
                borderRadius: '15px',
                marginRight: '15px',
                objectFit: 'cover',
                border: '3px solid #ff6b35',
              }}
            />
            <div>
              <h2 style={{ 
                fontSize: '26px', 
                fontWeight: 800, 
                margin: 0,
                background: 'linear-gradient(135deg, #ff6b35, #ffa500)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}>
                DOLLAR FURNITURE
              </h2>
              <Tag 
                color="orange" 
                style={{ 
                  marginTop: '5px',
                  fontWeight: 600,
                  border: 'none',
                  borderRadius: '12px',
                }}
              >
                <ThunderboltOutlined /> 24/7 SERVICE
              </Tag>
            </div>
          </div>
          
          <p style={{ 
            fontSize: '15px', 
            lineHeight: '1.7',
            color: '#bbb',
            marginBottom: '25px',
          }}>
            Your premier 24/7 furniture destination. Quality furniture, anytime you need it. 
            Visit our showroom or shop online round the clock.
          </p>
          
          {/* 24/7 Contact Box */}
          <div style={{ 
            backgroundColor: '#1a1a1a',
            padding: '20px',
            borderRadius: '12px',
            border: '2px solid #ff6b35',
            marginBottom: '20px',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
              <ClockCircleOutlined style={{ 
                fontSize: '20px', 
                color: '#ffa500',
                marginRight: '12px',
              }} />
              <div>
                <p style={{ fontSize: '14px', color: '#aaa', margin: 0 }}>Operating Hours</p>
                <p style={{ fontSize: '16px', fontWeight: 600, margin: '5px 0 0 0', color: '#ffa500' }}>
                  24 Hours / 7 Days
                </p>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
              <WhatsAppOutlined style={{ 
                fontSize: '20px', 
                color: '#25D366',
                marginRight: '12px',
              }} />
              <div>
                <p style={{ fontSize: '14px', color: '#aaa', margin: 0 }}>WhatsApp (24/7)</p>
                <p style={{ fontSize: '16px', fontWeight: 600, margin: '5px 0 0 0' }}>
                  +254 729 335 354
                </p>
              </div>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <EnvironmentOutlined style={{ 
                fontSize: '20px', 
                color: '#1890ff',
                marginRight: '12px',
              }} />
              <div>
                <p style={{ fontSize: '14px', color: '#aaa', margin: 0 }}>Location</p>
                <p style={{ fontSize: '15px', fontWeight: 500, margin: '5px 0 0 0' }}>
                  Kamakis Bypass, Ruiru
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Column 2: Shop Now Section */}
        <div>
          <h3 style={{ 
            fontSize: '18px', 
            marginBottom: '25px',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            color: '#ffa500',
          }}>
            <ShoppingOutlined />
            Shop Furniture
          </h3>
          
          <div style={{ 
            backgroundColor: '#1a1a1a',
            padding: '25px',
            borderRadius: '12px',
            border: '1px solid #333',
            textAlign: 'center',
          }}>
            <ShoppingOutlined style={{ fontSize: '48px', color: '#ff6b35', marginBottom: '15px' }} />
            <h4 style={{ color: '#fff', marginBottom: '10px' }}>Browse Our Collection</h4>
            <p style={{ color: '#bbb', fontSize: '14px', marginBottom: '20px' }}>
              Discover premium furniture for every room in your home
            </p>
            
            <Button
              type="primary"
              size="large"
              onClick={() => handleNavigation('/product')}
              style={{
                width: '100%',
                background: 'linear-gradient(135deg, #ff6b35, #ffa500)',
                border: 'none',
                borderRadius: '8px',
                height: '50px',
                fontWeight: 600,
                fontSize: '16px',
              }}
            >
              <ShoppingOutlined /> View All Products
            </Button>
            
            <Button
              type="default"
              size="large"
              onClick={() => handleNavigation('/product')}
              style={{
                width: '100%',
                marginTop: '15px',
                background: '#1a1a1a',
                borderColor: '#ff6b35',
                color: '#ff6b35',
                borderRadius: '8px',
                height: '45px',
                fontWeight: 600,
              }}
            >
              <GiftOutlined /> Special Offers
            </Button>
          </div>
        </div>

        {/* Column 3: Quick Navigation */}
        <div>
          <h3 style={{ 
            fontSize: '18px', 
            marginBottom: '25px',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            color: '#ffa500',
          }}>
            <HomeOutlined />
            Quick Links
          </h3>
          
          <div style={{ 
            backgroundColor: '#1a1a1a',
            padding: '25px',
            borderRadius: '12px',
            border: '1px solid #333',
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <Button
                type="text"
                onClick={() => handleNavigation('/')}
                style={{
                  textAlign: 'left',
                  color: '#ddd',
                  fontSize: '15px',
                  padding: '12px 15px',
                  backgroundColor: '#0a0a0a',
                  borderRadius: '8px',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#222';
                  e.currentTarget.style.color = '#ffa500';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#0a0a0a';
                  e.currentTarget.style.color = '#ddd';
                }}
              >
                <HomeOutlined style={{ marginRight: '10px' }} />
                Home
              </Button>
              
              <Button
                type="text"
                onClick={() => handleNavigation('/product')}
                style={{
                  textAlign: 'left',
                  color: '#ddd',
                  fontSize: '15px',
                  padding: '12px 15px',
                  backgroundColor: '#0a0a0a',
                  borderRadius: '8px',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#222';
                  e.currentTarget.style.color = '#ffa500';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#0a0a0a';
                  e.currentTarget.style.color = '#ddd';
                }}
              >
                <ShoppingOutlined style={{ marginRight: '10px' }} />
                All Products
              </Button>
              
              <Button
                type="text"
                onClick={() => handleNavigation('/contact')}
                style={{
                  textAlign: 'left',
                  color: '#ddd',
                  fontSize: '15px',
                  padding: '12px 15px',
                  backgroundColor: '#0a0a0a',
                  borderRadius: '8px',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#222';
                  e.currentTarget.style.color = '#ffa500';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#0a0a0a';
                  e.currentTarget.style.color = '#ddd';
                }}
              >
                <PhoneOutlined style={{ marginRight: '10px' }} />
                Contact Us
              </Button>
              
              <Button
                type="text"
                onClick={() => window.open('https://wa.me/254729335354', '_blank')}
                style={{
                  textAlign: 'left',
                  color: '#ddd',
                  fontSize: '15px',
                  padding: '12px 15px',
                  backgroundColor: '#0a0a0a',
                  borderRadius: '8px',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#222';
                  e.currentTarget.style.color = '#ffa500';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#0a0a0a';
                  e.currentTarget.style.color = '#ddd';
                }}
              >
                <WhatsAppOutlined style={{ marginRight: '10px' }} />
                WhatsApp Support
              </Button>
            </div>
          </div>
        </div>

        {/* Column 4: Map & Newsletter */}
        <div>
          {/* Map Section */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ 
              fontSize: '18px', 
              marginBottom: '15px',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              color: '#ffa500',
            }}>
              <EnvironmentOutlined />
              Visit Us Anytime
            </h3>
            <div style={{ 
              borderRadius: '12px',
              overflow: 'hidden',
              border: '2px solid #333',
              marginBottom: '15px',
            }}>
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d127647.6294043391!2d36.8371412625!3d-1.1686430000000068!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f417b84b77a15%3A0x46fb9c4e87d71ab6!2sDollar%20Furniture!5e0!3m2!1sen!2ske!4v1768072545603!5m2!1sen!2ske"
                width="100%" 
                height="200" 
                style={{ border: 0 }}
                allowFullScreen 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Dollar Furniture Location"
              />
            </div>
            <Button
              type="primary"
              block
              icon={<EnvironmentOutlined />}
              onClick={() => window.open('https://maps.app.goo.gl/qgLu78Vo6aZZceGN6', '_blank')}
              style={{
                background: '#1a1a1a',
                borderColor: '#ff6b35',
                color: '#ff6b35',
                fontWeight: 600,
              }}
            >
              Open in Google Maps
            </Button>
          </div>

          {/* Newsletter Section */}
          <div>
            <h3 style={{ 
              fontSize: '18px', 
              marginBottom: '15px',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              color: '#ffa500',
            }}>
              <MessageOutlined />
              24/7 Updates
            </h3>
            <p style={{ 
              fontSize: '14px', 
              color: '#bbb',
              marginBottom: '15px',
            }}>
              Get exclusive 24/7 offers and new arrivals
            </p>
            
            <Input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              size="large"
              style={{
                marginBottom: '10px',
                backgroundColor: '#1a1a1a',
                borderColor: '#444',
                color: 'white',
                borderRadius: '8px',
                padding: '12px 15px',
              }}
            />
            
            <Button
              type="primary"
              block
              size="large"
              loading={loading}
              onClick={handleEmailSubmit}
              icon={<MailOutlined />}
              style={{
                background: 'linear-gradient(135deg, #ff6b35, #ffa500)',
                border: 'none',
                borderRadius: '8px',
                fontWeight: 600,
                height: '45px',
                marginBottom: '20px',
              }}
            >
              Subscribe via WhatsApp
            </Button>
            
            {/* Social Media */}
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <Button
                shape="circle"
                size="large"
                onClick={() => window.open('https://www.instagram.com/dollar_furniture_ke', '_blank')}
                style={{
                  backgroundColor: '#1a1a1a',
                  borderColor: '#E4405F',
                  color: '#E4405F',
                  width: '45px',
                  height: '45px',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#E4405F';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#1a1a1a';
                  e.currentTarget.style.color = '#E4405F';
                }}
              >
                <InstagramOutlined />
              </Button>
              <Button
                shape="circle"
                size="large"
                onClick={() => window.open('https://facebook.com', '_blank')}
                style={{
                  backgroundColor: '#1a1a1a',
                  borderColor: '#1877F2',
                  color: '#1877F2',
                  width: '45px',
                  height: '45px',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1877F2';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#1a1a1a';
                  e.currentTarget.style.color = '#1877F2';
                }}
              >
                <FacebookOutlined />
              </Button>
              <Button
                shape="circle"
                size="large"
                onClick={() => window.open('https://twitter.com', '_blank')}
                style={{
                  backgroundColor: '#1a1a1a',
                  borderColor: '#1DA1F2',
                  color: '#1DA1F2',
                  width: '45px',
                  height: '45px',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1DA1F2';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#1a1a1a';
                  e.currentTarget.style.color = '#1DA1F2';
                }}
              >
                <TwitterOutlined />
              </Button>
              <Button
                shape="circle"
                size="large"
                onClick={() => window.open('https://wa.me/254729335354', '_blank')}
                style={{
                  backgroundColor: '#1a1a1a',
                  borderColor: '#25D366',
                  color: '#25D366',
                  width: '45px',
                  height: '45px',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#25D366';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#1a1a1a';
                  e.currentTarget.style.color = '#25D366';
                }}
              >
                <WhatsAppOutlined />
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div
        style={{
          marginTop: '50px',
          paddingTop: '30px',
          borderTop: '1px solid #333',
        }}
      >
        {/* Payment Methods */}
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <p style={{ 
            fontSize: '14px', 
            color: '#aaa',
            marginBottom: '15px',
          }}>
            Secure Payment Methods
          </p>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: '20px',
            flexWrap: 'wrap',
          }}>
            {paymentMethods.map((method, index) => (
              <div
                key={index}
                style={{
                  width: '80px',
                  height: '45px',
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '10px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                }}
                title={method.name}
              >
                <img
                  src={method.img}
                  alt={method.name}
                  style={{ 
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px',
          maxWidth: '1400px',
          margin: '0 auto',
        }}>
          <div style={{ fontSize: '14px', color: '#888' }}>
            © {new Date().getFullYear()} Dollar Furniture Kenya. 24/7 Service Available.
          </div>
          
          <div style={{ display: 'flex', gap: '25px', fontSize: '14px' }}>
            <Button 
              type="link" 
              onClick={() => handleNavigation('/product')}
              style={{ color: '#bbb', padding: 0 }}
            >
              Shop Now
            </Button>
            <Button 
              type="link" 
              onClick={() => handleNavigation('/product')}
              style={{ color: '#bbb', padding: 0 }}
            >
              All Products
            </Button>
            <Button 
              type="link" 
              onClick={() => handleNavigation('/contact')}
              style={{ color: '#bbb', padding: 0 }}
            >
              Contact Us
            </Button>
          </div>
        </div>
        
        {/* 24/7 Reminder */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '20px',
          padding: '15px',
          backgroundColor: '#1a1a1a',
          borderRadius: '10px',
          border: '1px solid #ff6b35',
        }}>
          <ClockCircleOutlined style={{ color: '#ffa500', marginRight: '10px' }} />
          <span style={{ color: '#ffa500', fontWeight: 600 }}>
            REMEMBER: We're open 24 hours, Monday to Sunday! Visit or call anytime.
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;